import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./views/Login/Login";
import OAuthCallback from "./views/OAuthCallback";
import PrivacyPolicy from "./views/Legal/PrivacyPolicy";
import TermsOfService from "./views/Legal/TermsOfService";
import SettingsPage from "./views/Settings/SettingsPage";
import MarketplaceShell from "./components/MarketplaceShell";
import MarketplaceRoute from "./components/MarketplaceRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import RolePicker from "./views/Marketplace/RolePicker";
import CreatorDirectory from "./views/Marketplace/CreatorDirectory";
import CreatorProfilePage from "./views/Marketplace/CreatorProfilePage";
import CreatorProfileEditor from "./views/Marketplace/CreatorProfileEditor";
import BrandProfileEditor from "./views/Marketplace/BrandProfileEditor";
import CampaignsPage from "./views/Marketplace/CampaignsPage";
import NewCampaign from "./views/Marketplace/NewCampaign";
import CampaignDetail from "./views/Marketplace/CampaignDetail";
import Opportunities from "./views/Marketplace/Opportunities";
import CollaborationsInbox from "./views/Marketplace/CollaborationsInbox";
import CollaborationRoom from "./views/Marketplace/CollaborationRoom";
import AssistantFullscreen from "./views/Marketplace/AssistantFullscreen";

/**
 * Marketplace surface.
 *
 * The ADVisor views (Projects, Teams, Dashboard, AgentWorkspace) still exist on
 * disk but are deliberately unrouted on this branch, so the pivot is a routing
 * change rather than a deletion and reverting is trivial if it does not
 * validate. Their Prisma models are untouched.
 */
function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/descubrir" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/oauth/callback" element={<OAuthCallback />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />

      {/* Public creator profile — the directory is the shop window, so a brand
          can browse and share a profile before signing in. */}
      <Route path="/creadores/:handle" element={<CreatorProfilePage />} />

      {/* Side selection. Guarded on auth only: the user has no role yet, so
          MarketplaceRoute would bounce them straight back here. */}
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <RolePicker />
          </ProtectedRoute>
        }
      />

      <Route
        element={
          <MarketplaceRoute>
            <MarketplaceShell />
          </MarketplaceRoute>
        }
      >
        <Route path="/descubrir" element={<CreatorDirectory />} />
        <Route path="/asistente" element={<AssistantFullscreen />} />
        <Route path="/perfil" element={<CreatorProfileEditor />} />
        {/* The brand's counterpart to /perfil, and the first thing a new brand
            account needs: without a BrandProfile every brand-side query scopes
            to nothing and campaigns cannot be created at all. */}
        <Route path="/marca" element={<BrandProfileEditor />} />
        {/* The creator's front door: invitations addressed to them plus the
            open campaigns they fit. `myInvitations` had no client reading it,
            so an invited creator never found out. */}
        <Route path="/oportunidades" element={<Opportunities />} />
        <Route path="/campanas" element={<CampaignsPage />} />
        {/* Before /campanas/:campaignId, or "nueva" is read as an id. */}
        <Route path="/campanas/nueva" element={<NewCampaign />} />
        <Route path="/campanas/:campaignId" element={<CampaignDetail />} />
        <Route path="/colaboraciones" element={<CollaborationsInbox />} />
        {/* After the index route, before nothing else — but kept adjacent so
            the ordering rule stays visible next to /campanas above. */}
        <Route path="/colaboraciones/:collaborationId" element={<CollaborationRoom />} />
        {/* No /billetera. It was a placeholder, and the catch-all below sends
            any stale bookmark to the directory. It returns with the payment
            clock, under a name that says what it does. */}
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/descubrir" replace />} />
    </Routes>
  );
}

export default App;
